const TYPE_PROPOSITION_VALUE = {
    ZTUDENT: 1,
    INSTRUCTOR: 2,
    LEADER: 3
}

export { TYPE_PROPOSITION_VALUE };